import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";

const pad = (num) => num.toString().padStart(2, "0");
const TIMES = [];
for (let minutes = 0; minutes < 24 * 60; minutes += 15) {
  const hour24 = Math.floor(minutes / 60);
  const min = minutes % 60;
  const value = `${pad(hour24)}:${pad(min)}`;

  // Determine display hour for 12-hour format
  let hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
  const period = hour24 < 12 ? "AM" : "PM";
  const label = `${hour12}:${pad(min)} ${period}`;
  
  TIMES.push({ label, value });
}

const TimeSelect = ({
  selectName,
  value,
  onChange,
  hasOvernight = false,
  className,
  size = "sm",
}) => {
  return (
    <Form.Select
      name={selectName}
      size={size}
      value={value}
      onChange={onChange}
      className={className}
    >
      {TIMES.map((t, i) => {
        return (
          <option key={i} value={t.value}>
            {t.label}
          </option>
        );
      })}
      {hasOvernight ? <option value="overnight">Overnight</option> : null}
    </Form.Select>
  );
};

TimeSelect.propTypes = {
  selectName: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  hasOvernight: PropTypes.bool,
  className: PropTypes.string,
};

export default TimeSelect;
